// extracted by mini-css-extract-plugin
export default {"Spinner":"PlateList_Spinner__zWOxK","NoFiles":"PlateList_NoFiles__zgIsr","Link":"PlateList_Link__XEiLI"};